import React, { useEffect, useState, useRef } from 'react';
import {
  FaHome,
  FaBox,
  FaFileAlt,
  FaClipboardList,
  FaChevronLeft,
  FaChevronRight,
  FaSignOutAlt,
  FaUsers,
  FaPager,
  FaNewspaper,
  FaCalculator,
  FaBook,
  FaScroll,
  FaMoneyBill,
  FaReceipt,
  FaBriefcase,
} from 'react-icons/fa';
import {
  FaArrowRightFromBracket,
  FaFileWaveform,
  FaHand,
  FaMagnifyingGlassChart,
  FaMapLocation,
  FaMapLocationDot,
  FaPersonDigging,
  FaTableCellsLarge,
  FaTicket,
} from 'react-icons/fa6';
import { useNavigate, useNavigation } from 'react-router';
import { useLocation } from 'react-router-dom';
import useAuthPermissions from '../../components/useAuthPermissions';
import { menuOptions } from '../../common/constants';
import ApiService from '../../services/ApiService';
import "./sidebar.css"
// Menu options for each role

// const Sidebar = ({ handleLogoutFlag }) => {
const Sidebar = ({ role, permission, handleLogoutFlag }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const menuRef = useRef(null);
  // const { permission, role } = useAuthPermissions();

  // const menuOptions = getMenuOptions(permission, role);
  // Get menu items based on role
  // const items = menuOptions || [];
  const items = menuOptions(permission, role) || [];

  useEffect(() => {
    const activeItem = items.find(
      (item) => item && item.route === location.pathname
    );

    if (activeItem) {
      setSelectedOption(activeItem.name);
    }
  }, [location.pathname, items]);

  useEffect(() => {
    const savedScroll = sessionStorage.getItem('sidebarMenuScroll');

    if (!savedScroll) return;

    const restore = () => {
      if (menuRef.current) {
        menuRef.current.scrollTop = Number(savedScroll);
      }
    };

    restore();
    setTimeout(restore, 100);
    setTimeout(restore, 300);
  }, [items.length, role]);

  const handleSidebarScroll = (e) => {
    sessionStorage.setItem(
      'sidebarMenuScroll',
      e.currentTarget.scrollTop
    );
  };

  // useEffect(() => {
  //   if (role === 'CEO') {
  //     localStorage.setItem('role', 'CEO');
  //   } else {
  //     localStorage.setItem('role', role);
  //     // localStorage.setItem('webUI', 'false');
  //     // localStorage.setItem('webUI', JSON.stringify(false));
  //   }
  // }, [role]);

  const roleFromStorage = localStorage.getItem('role') || '';
  const webUI = localStorage.getItem('webUI') === 'true';

  const ceoWebUIMenu = [
    {
      name: 'Homeone',
      icon: <img src="./home.png" />,
      route: '/homeone',
    },
    {
      name: 'Productsone',
      icon: <img src="./products.png" />,
      route: '/productsone',
    },
    {
      name: 'Reportsone',
      icon: <img src="./reports.png" />,
      route: '/reportsone',
    },
    {
      name: 'Clientsone',
      icon: <img src="./clients.png" />,
      route: '/clientsone',
    },
    // You can add more WebUI-specific items here
  ];

  // useEffect(() => {
  //   if (!role) return;

  //   // switch (localStorage.getItem('role')) {
  //   switch (role) {
  //     case 'CEO':
  //       navigate('/home');
  //       break;
  //     case 'Tele Calling Associate':
  //       navigate('/customer-care-home');
  //       break;
  //     case 'Accountant':
  //       navigate('/home');
  //       break;
  //     case 'Technician':
  //       navigate('/technician-home');
  //       break;
  //     case 'Warehouse Manager':
  //       navigate('/warehouse-manager-home');
  //       break;
  //     case 'Inventory Operational Analyst':
  //       navigate('/warehouse-manager-home');
  //       break;
  //     case 'sub dealer':
  //       navigate('/sub-dealer-home');
  //       break;
  //     case 'Sales Executive':
  //       navigate('/salesman-home');
  //       break;
  //     case 'Branch Manager':
  //       navigate('/branch-manager-home');
  //       break;
  //     case 'Backend Support Executive':
  //       navigate('/backend-support-home');
  //       break;
  //     case 'HR':
  //       navigate('/hr-home');
  //       break;
  //     default:
  //       navigate('/custom-home');
  //       break;
  //   }
  // }, []);

  // if (!permission || !role) {
  //   return <div className="text-white p-4">Loading sidebar...</div>;
  // }


  const handleLogout = async () => {
    const confirmLogout = window.confirm("Are you sure you want to logout?");
    if (confirmLogout) {
      try {
        await ApiService.post("/auth/logout");
      } catch (error) {
        console.error("Logout failed:", error);
      } finally {
        localStorage.clear();
        handleLogoutFlag();
        window.location.href = "/login";
      }
    }
  };

  const handleClick = (item) => {
    navigate(item.route);
    setSelectedOption(item.name);
  };

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <div className="sidebar-logo-wrap">
          <img
            src="/logo.png"
            alt="Company Logo"
            className="sidebar-logo"
          />
        </div>
      </div>

      {/* <div className="sidebar-menu"> */}
      <div
        className="sidebar-menu"
        ref={menuRef}
        onScroll={handleSidebarScroll}
      >
        {items.map(
          (item, index) =>
            item && (
              <div
                key={index}
                className={`sidebar-item ${item.name === selectedOption ? "active" : ""
                  }`}
                onClick={() => handleClick(item)}
              >
                <span className="sidebar-icon">
                  {item.icon}
                </span>

                <span className="sidebar-text">
                  {item.name}
                </span>
              </div>
            )
        )}
      </div>

      <div className="sidebar-footer">
        <button
          className="logout-btn"
          onClick={handleLogout}
        >
          <span className="logout-icon">
            <FaArrowRightFromBracket />
          </span>

          Logout
        </button>
      </div>
    </div>
  );
};

export default Sidebar;


// const groupByBranch = (data) => {
//   const grouped = {};

//   data.forEach((item) => {
//     const { branchId, branchName, productName, productCount } = item;

//     if (!grouped[branchId]) {
//       grouped[branchId] = {
//         branchId,
//         branchName,
//         products: [],
//       };
//     }

//     grouped[branchId].products.push({ productName, productCount });
//   });

//   return Object.values(grouped);
// };